import { getSessionCookie } from './sessionId';
import { getSubdomain, getParameterByName } from '../utils/helper';
import { ANALYTICS_API_URL } from '../constants/constants';

export const sendData = (rId, cName, cCategory, uType, args) => {
    const sessionId = getSessionCookie();
    const subDomain = getSubdomain();
    let rockmanId = ''
    if(sessionStorage.getItem('authorized') && JSON.parse(sessionStorage.getItem('authorized')).success === true){
        rockmanId = JSON.parse(sessionStorage.getItem('authorized')).rockmanId
    }
    let rid = new URL(window.location.href).searchParams.get('rid')
    if(uType === 'Accessed'){
        rockmanId = rId
    }
    if((rockmanId && rockmanId.length > 0) || (rid && rid.length > 0 && uType !== 'Accessed') ){
        const data = {
            r: rockmanId && rockmanId.length > 0 ? rockmanId : rid,
            portal_session_id: sessionId,
            d: [
                {
                    t: "content_usage",
                    a: {
                        content_name: cName,
                        content_category: cCategory,
                        content_type: "video",
                        usage_type: uType,
                        args: args,
                        product_name: "mobiotv",
                        subdomain: subDomain
                    }
                }
            ]
        };
        if(getSubdomain() === 'localhost'){
            console.log({rid: data.r, uType: data.d[0].a.usage_type})
            return;
        }   
        var xhr = new XMLHttpRequest();
        xhr.open('POST', ANALYTICS_API_URL, true);
        xhr.send(JSON.stringify(data));
    }
    return;
}


// WEBPACK FOOTER //
// ./src/analytics/sendData.js